import React from 'react';

function EditRole(props) {
    return (
        <div></div>
    );
}

export default EditRole;